export default __webpack_public_path__ + "static/media/kmlogo.2268334f.svg";